import i18n from "@/libs/i18n";
import axios from "@/libs/axios";
import { computed, ref, watch } from "@vue/composition-api";

export default function useTeamsList() {
    const refTable = ref(null);
    const tableColumns = [
        { key: "name", label: i18n.t("settings.teams.name.key"), sortable: true },
        { key: "channels", label: i18n.t("settings.teams.channels.key") },
        { key: "teamUsers", label: i18n.t("settings.teams.users.key") },
        { key: "color", label: i18n.t("settings.teams.color.key"), sortable: true },
        { key: "actions", label: i18n.t("settings.teams.actions") },
    ];
    const perPage = ref(10);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("name");
    const isSortDirDesc = ref(false);
    const users = ref([]);
    const isLoading = ref(true);

    const dataMeta = computed(() => {
        const localItemsCount = refTable.value ? refTable.value.localItems.length : 0;

        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: total.value,
        };
    });

    const refetchData = () => {
        refTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        if (searchQuery.value.length > 0 && searchQuery.value.length < 2) {
            return;
        }

        refetchData();
    });

    axios.get("users").then((result) => (users.value = result.data));

    const read = (ctx, callback) => {
        axios
            .get("teams", {
                params: {
                    fields: "name,color",
                    s: {
                        $or: [{ name: { $cont: searchQuery.value } }, { color: { $cont: searchQuery.value } }],
                    },
                    join: ["teamUsers", "channels"],
                    limit: perPage.value,
                    page: currentPage.value,
                    sort: `${sortBy.value},${isSortDirDesc.value === true ? "DESC" : "ASC"}`,
                },
            })
            .then((response) => {
                callback(response.data.data);
                total.value = response.data.total;
            })
            .finally(() => (isLoading.value = false));
    };

    const getUsersAssignedToTeam = (teamUsers) => {
        return teamUsers.map((teamUser) => {
            return (
                users.value.find((user) => user.id === teamUser.userId) || {
                    id: teamUser.userId,
                    name: i18n.t("settings.teams.deleted-user"), // Fallback, this should not happen. But it can when there is some leftover data.
                }
            );
        });
    };

    return {
        read,
        refetchData,
        tableColumns,
        perPage,
        currentPage,
        total,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTable,
        getUsersAssignedToTeam,
        isLoading,
    };
}
